import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfoModal from '../InfoModal';
const LegalInfoModal = ({ modalContent, linkText }) => {
    return (_jsxs("span", Object.assign({ className: "modal-container legal-info", "data-testid": "legal-info-modal" }, { children: [_jsx("a", Object.assign({ "data-bs-toggle": "offcanvas", href: "#legal-info-modal", role: "button", "aria-controls": "legal-info-modal", "data-testid": "modal-link" }, { children: linkText })), ".", _jsx(InfoModal, { modalContent: modalContent, modalType: "legal-info-modal" })] })));
};
export default LegalInfoModal;
